<div class="container-fluid mt-4">

  <div class="d-flex justify-content-between mb-3">
    <h4> <i class="fi fi-rr-admin-alt"></i> ადმინების სია</h4>
     <!-- დამატება -->
     <button class="btn btn-primary " (click)="openModalForAdd()">დამატება</button>
  </div>

  <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

  <!-- Error Message -->
  <div *ngIf="error" class="alert alert-danger">
    მოხდა შეცდომა ადმინის სიის მიღებისას.
  </div>

  <!-- Tickets Table -->
   <div class="table-responsive">
    <table *ngIf="!load && !error && data?.length > 0" class="table table-hover table-bordered mt-3">
      <thead >
        <tr>
          <th>#</th>
          <th>სახელი</th>
          <th>გვარი</th>
          <th>მომხმარებელი</th>
          <th>უფლება</th>
          <th>პარამეტრები</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of data; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ user.name }}</td>
          <td>{{ user.lastname }}</td>
          <td>{{ user.user }}</td>
          <td>{{ user.role }}</td>
          <td>
              <!-- რედაქტირება -->
              <div class="d-flex">
                <button class="btn btn-sm border rounded d-flex align-items-center mx-2" (click)="openEditAdminModal(user)">
                    <i class="fi fi-rr-pencil"></i>
                </button> 
          
                <button type="button" class="btn btn-sm text-danger border rounded d-flex align-items-center mx-2"
                      (click)="confirmDelete(user)">
                      <app-spinner *ngIf="deleteUserId === user.id" [sm]="true" [loading]="true"></app-spinner>
                      <i *ngIf="deleteUserId !== user.id" class="fi fi-rr-trash"></i>
                </button>        
              </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- No Data -->
  <div *ngIf="!load && !error && data?.length === 0" class="alert alert-warning">
    ადმინები ვერ მოიძებნა.
  </div>



</div>





<!-- მომხმარებლის რედაქტირების მოდალი -->
<ng-template #editAdminModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">ადმინის რედაქტირება</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    

    <form [formGroup]="form" (ngSubmit)="submit()">

  <!-- BASIC INFO -->
  <div class="row g-3">
    <div class="col-md-4">
      <div class="form-floating">
        <input formControlName="user" id="user" type="text" class="form-control" placeholder="ლოგინი">
        <label for="user">ლოგინი</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-floating">
        <input formControlName="name" id="name" type="text" class="form-control" placeholder="სახელი">
        <label for="name">სახელი</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-floating">
        <input formControlName="lastname" id="lastname" type="text" class="form-control" placeholder="გვარი">
        <label for="lastname">გვარი</label>
      </div>
    </div>

    <!-- password: add-ზე სავალდებულო, edit-ზე optional (TS-ში გავაკონტროლებთ) -->
    <div class="col-md-6">
      <div class="form-floating">
        <input formControlName="password" id="password" type="password" class="form-control" placeholder="პაროლი">
        <label for="password">პაროლი</label>
      </div>
      <div class="form-text">
        რედაქტირებისას თუ არ შეცვლი — დატოვე ცარიელი.
      </div>
    </div>

    <!-- ROLE -->
    <div class="col-md-6">
      <div class="form-floating">
        <select formControlName="role" id="role" class="form-select">
          <option value="manager">Manager</option>
          <option value="admin">Admin</option>
        </select>
        <label for="role">როლი</label>
      </div>
      <div class="form-text">
        Admin = სრული უფლებები, Manager = შეზღუდული (permissions-ით).
      </div>
    </div>
  </div>

  <hr class="my-4">

  <!-- PERMISSIONS -->
  <div class="d-flex align-items-center justify-content-between mb-2">
    <h5 class="mb-0">უფლებები</h5>

    <!-- სწრაფი ღილაკები -->
    <div class="btn-group btn-group-sm">
      <button type="button" class="btn btn-outline-secondary" (click)="selectAllPermissions(true)">
        ყველა
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="selectAllPermissions(false)">
        none
      </button>
    </div>
  </div>

  <!-- permissions: FormGroup -->
  <div formGroupName="permissions" class="row g-3">
    <!-- MENUS -->
    <div class="col-lg-6">
      <div class="p-3 border rounded-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>მენიუ</strong>
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-outline-secondary" (click)="toggleModule('menus', true)">ყველა</button>
            <button type="button" class="btn btn-outline-secondary" (click)="toggleModule('menus', false)">none</button>
          </div>
        </div>

        <div class="d-flex flex-wrap gap-3">
          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="menus_view">
            <span class="form-check-label">ნახვა</span>
          </label>

          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="menus_create">
            <span class="form-check-label">დამატება</span>
          </label>

          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="menus_edit">
            <span class="form-check-label">რედაქტირება</span>
          </label>

          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="menus_delete">
            <span class="form-check-label">წაშლა</span>
          </label>
        </div>
      </div>
    </div>

    <!-- PAGES -->
    <!-- <div class="col-lg-6">
      <div class="p-3 border rounded-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>გვერდები (Page content)</strong>
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-outline-secondary" (click)="toggleModule('pages', true)">ყველა</button>
            <button type="button" class="btn btn-outline-secondary" (click)="toggleModule('pages', false)">none</button>
          </div>
        </div>

        <div class="d-flex flex-wrap gap-3">
          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="pages_view">
            <span class="form-check-label">ნახვა</span>
          </label>

          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="pages_create">
            <span class="form-check-label">დამატება</span>
          </label>

          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="pages_edit">
            <span class="form-check-label">რედაქტირება</span>
          </label>

          <label class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="pages_delete">
            <span class="form-check-label">წაშლა</span>
          </label>
        </div>
      </div>
    </div> -->

    <!-- ADMIN PANEL ACCESS -->
    <div class="col-12">
      <div class="p-3 border rounded-3 h-100">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong>ადმინის პანელის გვერდებზე წვდომა</strong>
        </div>

        <div class="row g-2">
          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="posts">
              <span class="form-check-label">სტატიები</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="calendar">
              <span class="form-check-label">კალენდარი</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="team">
              <span class="form-check-label">ჩვენი გუნდი</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="banner">
              <span class="form-check-label">მარჯვენა ბლოკი</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="forms">
              <span class="form-check-label">ფორმები</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="faq">
              <span class="form-check-label">კითხვა პასუხი</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="gallery">
              <span class="form-check-label">გალერეა</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="files">
              <span class="form-check-label">ფაილები</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="live">
              <span class="form-check-label">ლაივი</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="comments">
              <span class="form-check-label">კომენტარები</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="admins">
              <span class="form-check-label">ადმინები</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="settings">
              <span class="form-check-label">პარამეტრები</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="logs">
              <span class="form-check-label">ლოგები</span>
            </label>
          </div>

          <div class="col-md-3 col-sm-6">
            <label class="form-check">
              <input class="form-check-input" type="checkbox" formControlName="info">
              <span class="form-check-label">ინფო</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <hr class="my-4">

  <!-- MENU ACCESS -->
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h5 class="mb-0">წვდომა კონკრეტულ მენიუებზე</h5>
    <small class="text-muted">თუ ცარიელია → ნიშნავს ყველა მენიუზე აქვს წვდომა (Admin ან full access)</small>
  </div>

  <!-- ეს block მხოლოდ manager-ზე ან როცა pages_edit/pages_view მონიშნულია -->
  <div class="row g-3">
    <div class="col-12">
      <div class="p-3 border rounded-3">

        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
          <div>
            <strong>მენიუებზე წვდომა</strong>
            <div class="text-muted small">აირჩიე კონკრეტული მენიუები, რომლებზეც ამ ადმინს ექნება წვდომა</div>
          </div>

          <div class="btn-group btn-group-sm">
            <button
              type="button"
              class="btn btn-outline-secondary"
              (click)="selectAllMenus()">
              ყველა
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary"
              (click)="clearAllMenus()">
              გასუფთავება
            </button>
          </div>
        </div>

        <div class="form-floating mb-3">
          <input
            type="text"
            class="form-control"
            id="menuSearch"
            [(ngModel)]="menuSearch"
            [ngModelOptions]="{ standalone: true }"
            placeholder="მოძებნე მენიუ">
          <label for="menuSearch">მოძებნე მენიუ</label>
        </div>

        <div class="border rounded-3 p-3" style="max-height: 320px; overflow: auto;">
          <div class="row g-2" *ngIf="getFilteredMenuOptions().length; else noMenusFound">
            <div class="col-md-6 col-lg-4" *ngFor="let m of getFilteredMenuOptions(); trackBy: trackByMenuId">
              <label class="form-check border rounded-3 px-3 py-2 w-100 h-100 d-flex align-items-start gap-2">
                <input
                  class="form-check-input mt-1"
                  type="checkbox"
                  [checked]="isMenuSelected(m.id)"
                  (change)="toggleMenuSelection(m.id, $any($event.target).checked)">

                <span class="form-check-label">
                  {{ m.title }}
                </span>
              </label>
            </div>
          </div>
        </div>

        <ng-template #noMenusFound>
          <div class="text-muted small">მენიუ ვერ მოიძებნა.</div>
        </ng-template>

        <div class="form-text mt-2">
          თუ არაფერი აირჩა, სისტემამ შეიძლება ეს აღიქვას როგორც ყველა მენიუზე წვდომა — ზუსტად ისე, როგორც შენს backend ლოგიკაში გაქვს.
        </div>

      </div>
    </div>
  </div>

  <!-- ACTIONS -->
  <div class="d-flex gap-2 justify-content-end mt-4">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
      გაუქმება
    </button>

    <button type="submit" class="btn btn-primary" [disabled]="loading">
      <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
      შენახვა
    </button>
  </div>

</form>

 
  </div>
  
</ng-template>